import $ from 'jquery';

export default class GtmLivestreamings {
  static init(){
    this.bindUserAvatars();
    this.bindLiveChats();
  }

  static bindUserAvatars() {
    $('.livestreaming-discussion__container').on('click', '.livestreaming-discussion-item__username', function() {
      var id = $(this).data('id');

      window.dataLayer.push({
        event: 'user profile',
        feature_name: 'live-watch now',
        feature_location: 'chat',
        feature_type: 'user.' + id
      });
    });

    $('.user-avatar__link').on('click',function(){
      var id = $(this).data('id');

      window.dataLayer.push({
        event: 'user profile',
        feature_name: 'live-watch now',
        feature_location: 'content',
        feature_type: 'user.' + id
      });
    });
  }

  static bindLiveChats() {
    var id = $('meta[name=page]').data('id');

    $('.livestreaming-discussion__form').on('submit', function(){
      window.dataLayer.push({
        event: 'livechat',
        feature_name: 'live-watch now',
        feature_location: 'submit',
        feature_type: 'live.' + id
      });
    });

    $('.livestreaming-discussion__table-item-emoji').on('click', function(){
      window.dataLayer.push({
        event: 'livechat',
        feature_name: 'live-watch now',
        feature_location: 'emoji',
        feature_type: 'live.' + id
      });
    });

    $('.livestreaming-discussion__table-item-sticker').on('click', function(){
      window.dataLayer.push({
        event: 'livechat',
        feature_name: 'live-watch now',
        feature_location: $(this).data('pack-name'),
        feature_type: `live.${id}/sticker.${$(this).data('name')}`
      });
    });
  }
}
